var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TypeKind } from "graphql";
import { GET_LIST, GET_MANY, GET_MANY_REFERENCE } from "react-admin";
import getFinalType from "./utils/getFinalType";
var sanitizeResource = function (introspectionResults, resource, shouldSanitizeLinkedResources) {
    if (shouldSanitizeLinkedResources === void 0) { shouldSanitizeLinkedResources = true; }
    return function (data) {
        if (data === void 0) { data = {}; }
        return Object.keys(data).reduce(function (acc, key) {
            var _a, _b, _c, _d;
            var _e;
            if (key.startsWith("_")) {
                return acc;
            }
            var field = resource.type.fields.find(function (f) { return f.name === key; });
            var type = getFinalType(field.type);
            if (type.kind !== TypeKind.OBJECT) {
                return __assign(__assign({}, acc), (_a = {}, _a[field.name] = data[field.name], _a));
            }
            // FIXME: We might have to handle linked types which are not resources but will have to be careful about endless circular dependencies
            var linkedResource = introspectionResults.resources.find(function (r) { return r.type.name === type.name; });
            if (shouldSanitizeLinkedResources && linkedResource) {
                var linkedResourceData = data[field.name];
                if (Array.isArray(linkedResourceData)) {
                    return __assign(__assign({}, acc), (_b = {}, _b[field.name] = data[field.name].map(function (obj) { return obj.id; }), _b));
                }
                return __assign(__assign({}, acc), (_c = {}, _c[field.name] = (_e = data[field.name]) === null || _e === void 0 ? void 0 : _e.id, _c));
            }
            return __assign(__assign({}, acc), (_d = {}, _d[field.name] = data[field.name], _d));
        }, {});
    };
};
export default (function (introspectionResults, _a) {
    var _b = _a.shouldSanitizeLinkedResources, shouldSanitizeLinkedResources = _b === void 0 ? true : _b, queryDialect = _a.queryDialect;
    return function (aorFetchType, resource) {
        return function (response) {
            var sanitize = sanitizeResource(introspectionResults, resource, shouldSanitizeLinkedResources);
            var data = response.data;
            var getTotal = function () {
                var _a;
                switch (queryDialect) {
                    case "nexus-prisma":
                        return response.data.total;
                    case "typegraphql":
                        return ((_a = response.data.total._count) !== null && _a !== void 0 ? _a : response.data.total.count)._all;
                }
            };
            if (aorFetchType === GET_LIST ||
                aorFetchType === GET_MANY ||
                aorFetchType === GET_MANY_REFERENCE) {
                return {
                    data: response.data.items.map(sanitize),
                    total: getTotal(),
                };
            }
            return { data: sanitize(data.data) };
        };
    };
});
//# sourceMappingURL=getResponseParser.js.map